import { DefaultTheme } from "@/constants/DefaultTheme";

export const DarkTheme = {
  ...DefaultTheme,
  dark: true,
};
